const ExcelDataImportCtrl = require('./ExcelDataImportCtrl');
const BatchDataUploadCtrl = require('./BatchDataUploadCtrl');
const NewBatchDataUploadCtrl = require('./NewBatchDataUploadCtrl');

angular.module('backstage.controllers.data', [])
    .controller('ExcelDataImportCtrl', ExcelDataImportCtrl)
    .controller('BatchDataUploadCtrl', BatchDataUploadCtrl)
    .controller('NewBatchDataUploadCtrl', NewBatchDataUploadCtrl);
